<template>
  <div class="bar-chart has-spinner">
    <img class="has-spinner__spinner" src="/static/img/loaders/spinner.svg" v-if="isLoading">
    <vue-chart
      :columns="chartColumns"
      :key="keyIdx"
      :options="chartOptions"
      :rows="chartRows"
      chart-type="LineChart"/>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc,one-var */
  import {mapState} from 'vuex'
  import axios from 'axios'
  import {misc, charts} from '@/mixins'

  export default {
    name: 'AverageRating',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Review Analytics'
    },
    mixins: [misc, charts],
    props: {
      dateFilter: {
        type: Object,
        required: true
      },
      review: {
        type: Object,
        required: true
      },
      replyTime: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        chartColumns: [
          {
            type: 'string',
            label: 'Date'
          },
          {
            type: 'number',
            label: 'Average Rating'
          }
        ]
      }
    },
    computed: {
      ...mapState({
        analyticsData: state => state.analytics
      }),
      /**
       * Creating a payload for HTTP request
       * @return {object}
       */
      payload () {
        return {
          endDate: this.dateFilter.endDate,
          startDate: this.dateFilter.startDate,
          dateInterval: this.customLabel(this.dateFilter.startDate, this.dateFilter.endDate),
          businessSlug: this.businessSlug,
          review: this.review,
          replyTime: this.replyTime
        }
      }
    },
    created () {
      this.fetchAnalyticsStats()
    },
    methods: {
      /**
       * Fetching the review analytics stats
       * @return {void}
       */
      fetchAnalyticsStats () {
        const payload = JSON.parse(JSON.stringify(this.payload))
        if (payload.endDate) {
          this.isLoading = true
          this.chartRows = []
          axios.get(`/analytics/${payload.businessSlug}/reviews/rating-over-time`, {
            params: payload
          })
            .then(({data}) => {
              this.chartRows = data.data.averageRating
              this.isLoading = false
              this.keyIdx++

              this.analyticsData['common']['chartReviewsCount'] = data.data.common.chartReviewsCount
              this.analyticsData['common']['chartAvgStarRating'] = data.data.common.chartAvgStarRating
              this.analyticsData['common']['chartAvgReplyTime'] = data.data.common.chartAvgReplyTime
              this.analyticsData['common']['ratingData'] = data.data.common.ratingData
              this.analyticsData['common']['deletedReviewsCount'] = data.data.common.deletedReviewsCount
              this.analyticsData['common']['responseRateData'] = data.data.common.responseRateData
              window.events.$emit('dataFetched_ra')
            })
        }
      }
    },
    watch: {
      payload (newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.fetchAnalyticsStats()
        }
      }
    }
  }
</script>

<style scoped>
  @import './common.css';
</style>



// WEBPACK FOOTER //
// src/pages/analytics/reviews/AverageRating.vue